// extracted by mini-css-extract-plugin
export default {"tableContainer":"UnpaidReceiptsGrid_tableContainer__4TF2B","table":"UnpaidReceiptsGrid_table__K3djo","row":"UnpaidReceiptsGrid_row__CyPXm"};